import React from 'react'
import './button.css'
import { useNavigate } from 'react-router-dom'
import { HiOutlineCalendar } from 'react-icons/hi';
import { useNavigation } from "../../hooks/navigationContext";

const icons = {
  calendar: HiOutlineCalendar
}

const Button = ({ Style, Label, Action, Direction, Icon }) => {

  const SelectedIcon = icons[Icon];
  const navigate = useNavigate();
  const { setDirection } = useNavigation();

  const action = () => {
    Direction === "Next" ? setDirection(1) : setDirection(-1);
    navigate(Action);
  }


  return (
    <div>
      <button className={`button ${Style}`} onClick={action}><SelectedIcon /> {Label}</button>
    </div>
  )
}



export default Button
